import React from "react";
import { Alert, Button, Col, DatePicker, Form, Modal, Row, Select, Spin, theme, Input } from "antd";
import { useForm } from "antd/es/form/Form";
import { FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
// import Header from "../common/Header";
import moment from "moment";
// import { DATE_FORMAT, DELIVERY_TRANSACTION_STATE,
//   REPORT_FILTER, REPORT_FILTER_TH, 
//   TREE_GENDER_OPTIONS, INFLORESCENCE_REPORT_ACTION_OPTIONS, 
//   INFLORESCENCE_QC_PASSED_OPTIONS } from "../../constants/strings";
import propTypes from "prop-types";
// import useDropdownItem from "../../hooks/useDropdownItem";
// import { URL_COMMON, URL_DELIVERY,  } from "../../constants/urls";
import { GET } from "../../frameworks/HttpClient";
import _ from 'lodash'
import { DATE_FORMAT, MONTH_FORMAT, REPORT_FILTER, REPORT_FILTER_TH } from "../../constants/string";
import { URL_CHEMICAL, URL_SALE, URL_SETTING, URL_SKIM, URL_TANK, URL_CUSTOMER } from "../../constants/urls";
import useDropdownItem from "../../common/useDropdownItem";
import ReportTankTransactionTable from "./ReportTankTransactionTable";
import ReportSaleOrderTable from "./ReportSaleOrderTable";
import ReportSaleOrderTableSkim from "./ReportSaleOrderSkimTable";

const SEARCH_DELAY_MILLISECONDS = 800;

export default function ReportModal(props) {
  const [form] = useForm();
  const {open, onClose} = props;
  const [pdfLoading, setPDFLoading] = React.useState(false);
	const [excelLoading, setExcelLoading] = React.useState(false);
  const [errorMessages, setErrorMessages] = React.useState(null);
  const [data, setData] = React.useState(null); 
  const haveFilter = (data?.filters && data.filters.length === 0 ? false : true)
  const bankDropdown = useDropdownItem({ 
    url: URL_SETTING.BANK_ACCOUNT, 
    label_renderer : (data) => `${data.bank_name} - ${data.account_no}`,
    value:'id', 
    pagination: true, 
    params: { page_size: 999 } 
  })
  const [debouncedPureChemical, setDebouncedPureChemical] = React.useState('');
  const debouncePureChemical = React.useCallback(_.debounce((_searchVal) => { setDebouncedPureChemical(_searchVal) }, 800), []);
  const pureChemicalDropdown = useDropdownItem({
    manual: true, 
    url: URL_CHEMICAL.PURE_CHEMICAL, 
    label: 'name', 
    value:'id', 
    pagination: true, 
    params: { page_size: 999, name: debouncedPureChemical } 
  })

  const [debouncedSkimChemical, setDebouncedSkimChemical] = React.useState('');
  const debounceSkimChemical = React.useCallback(_.debounce((_searchVal) => { setDebouncedSkimChemical(_searchVal) }, 800), []);
  const skimChemicalDropdown = useDropdownItem({
    manual: true, 
    url: URL_SKIM.SKIM_CHEMICAL, 
    label: 'name', 
    value:'id', 
    pagination: true, 
    params: { page_size: 999, name: debouncedSkimChemical } 
  })

  const [debouncedTankTransaction, setDebouncedTankTransaction] = React.useState('');
  const debounceTankTransaction = React.useCallback(_.debounce((_searchVal) => { setDebouncedTankTransaction(_searchVal) }, 800), []);
  const tankTransactionDropdown = useDropdownItem({
    manual: true, 
    url: URL_TANK.TANK_TRANSACTION, 
    label: 'lot_no', 
    value:'id', 
    pagination: true, 
    params: { page_size: 999, lot_no: debouncedTankTransaction } 
  })
  
  const [debouncedSaleOrder, setDebouncedSaleOrder] = React.useState('');
  const debounceSaleOrder = React.useCallback(_.debounce((_searchVal) => { setDebouncedSaleOrder(_searchVal) }, 800), []);
  const saleOrderDropdown = useDropdownItem({
    manual: true, 
    url: URL_SALE.SALE_ORDER, 
    label: 'order_no', 
    value:'id', 
    pagination: true, 
    params: { page_size: 999, order_no: debouncedSaleOrder } 
  })
  

  const [debouncedCustomer, setDebouncedCustomer] = React.useState('');
  const debounceCustomer = React.useCallback(_.debounce((_searchVal) => { setDebouncedCustomer(_searchVal) }, 800), []);
  const customerDropdown = useDropdownItem({
    manual: true, 
    url: URL_SALE.SALE_BUYER, 
    label: 'name', 
    value:'id', 
    pagination: true, 
    params: { page_size: 999, name: debouncedCustomer } 
  })

  const [debouncedSupplier, setDebouncedSupplier] = React.useState('');
  const debounceSupplier = React.useCallback(_.debounce((_searchVal) => { setDebouncedSupplier(_searchVal) }, 800), []);
  const supplierDropdown = useDropdownItem({
    manual: true, 
    url: URL_CUSTOMER.RAW_LATEX_SUPPLIER, 
    label_renderer: (item) => `${item.code}: ${item.name}`,
    value:'id', 
    pagination: true, 
    params: { page_size: 999, name: debouncedSupplier } 
  })

  // const treeTypeDropdown = useDropdownItem({ url: URL_PALMTREE.TREE_TYPE, label: 'name', value:'id', pagination: true, params: { page_size: 999 } })
  // const productionTypeDropdown = useDropdownItem({ url: URL_COMMON.PRODUCTION_TYPE, label: 'name', pagination: true, params: { page_size: 999 } })
  // const speciesDropdown = useDropdownItem({ url: URL_PALMTREE.SPECIES, label: 'title', pagination: true, params: { page_size: 999 } })
  // const kernelTypeDropdown = useDropdownItem({ url: URL_PALMTREE.KERNEL_TYPE, label: 'name', pagination: true, params: { page_size: 999 } })
  // const plamTreeDropdown = useDropdownItem({ url: URL_PALMTREE.PALMTREE, label: 'code', pagination: true, params: { page_size: 50 } })
  // const plotDropdown = useDropdownItem({ url: URL_PALMTREE.PLOT, label: 'code', pagination: true, params: { page_size: 999 } })


  // const [deliveryParams, setDeliveryParams] = React.useState({code: ''})
  // const deliveryDropdown = useDropdownItem({ 
  //   url: URL_DELIVERY.DELIVERY_TRANSACTION, 
  //   label: 'code', 
  //   pagination: true, 
  //   params: {is_active: true, state : DELIVERY_TRANSACTION_STATE.RECEIVED, ...deliveryParams} })
  // const plantationWatch = Form.useWatch('plantation', form);

  const {
		token: { colorSuccessTextActive, colorErrorTextActive }
	} = theme.useToken();

  // const debounceDelivery = React.useCallback(
  //   _.debounce((_searchVal) => {
  //     setDeliveryParams({code: _searchVal})
  //   }, 800),
  //   []
  // )

  const handleSubmit = async (exportType) => {
		let url = data.url
		if (!url) {
			setErrorMessages("Report not found!");
			return;
		}

		// Set loading
		props.onStartLoading(exportType)
		if (exportType === "pdf")
			setPDFLoading(true);
		else
			setExcelLoading(true);
	
		// Prepare data
		setErrorMessages(null);
		try {
			const values = await form.validateFields();
			const params = getParams(values, exportType);
      const additional_params = data?.params ? data.params : {}
      const pkUrl = _.get(data, 'pathUrl', null) ? _.get(params, `${_.get(data, 'pathUrl', null)}`, '') : ''
      
			// Goto export
			const response = await GET(`${url}${pkUrl}`, {...params, ...additional_params}, false, true) // Download as blob
      const fileURL = URL.createObjectURL(response.data)
			
			if(exportType === "excel" && props.namePrefix != null) {
				const fileLink = document.createElement('a');
				fileLink.href = fileURL;
				fileLink.download = `${props.namePrefix.replace(/ /g, "_")}_${moment().unix() }.xlsx`;
				fileLink.click();
				setTimeout(() => {fileLink.remove()}, 100);
			}
			else {
				setTimeout(() => {window.open(fileURL, '_blank')})
			}
			props.onClose();

		} catch (error) {
			if (error.errorMessages) 
				setErrorMessages(error.errorMessages);
		}

		finally {
			props.onEndLoading()
			if (exportType === "pdf")
				setPDFLoading(false);
			else
				setExcelLoading(false);
		}
	}

  const filterOption = (input, option) =>
  (option?.label ?? '').toLowerCase().includes(input.toLowerCase())

  const isShowElement = (list, targetName) => {
    return list.find(({ name }) => name === targetName) ? true : false;
  }

  const isRequired = (list, targetName) => {
    const item = list.find(({ name }) => name === targetName);
    return item.required ? true : false;
  }

  const getPlaceHolder = (list, targetName) => {
    const item = list.find(({ name }) => name === targetName);
    return item.placeholder
  }

  const getParams = (values, exportType) => {
    let params = {...values}
    if (values[REPORT_FILTER.DATE]) {
      params["date"] = values[REPORT_FILTER.DATE].format(DATE_FORMAT);
    }
    if (values[REPORT_FILTER.DATE_RANGE]) {
      params["date_after"] = values[REPORT_FILTER.DATE_RANGE][0].format(DATE_FORMAT);
      params["date_before"] = values[REPORT_FILTER.DATE_RANGE][1].format(DATE_FORMAT);
      delete params[REPORT_FILTER.DATE_RANGE]
    }
    if (values[REPORT_FILTER.MONTH]) {
      params["month"] = values[REPORT_FILTER.MONTH].format(MONTH_FORMAT);
    }
    if (values[REPORT_FILTER.MONTH_RANGE]) {
      params["from_month"] = values[REPORT_FILTER.MONTH_RANGE][0].format(MONTH_FORMAT);
      params["to_month"] = values[REPORT_FILTER.MONTH_RANGE][1].format(MONTH_FORMAT);
      delete params[REPORT_FILTER.MONTH_RANGE]
    }
    
    params["export_type"] = exportType
    return params;
  }

  React.useEffect(() => {
    if (open) {
      setErrorMessages(null);
      form.resetFields();
    }
  }, [open])

  React.useEffect(() => {
		setData(props.data);
	}, [props.data])

  React.useEffect(() => {
    if(data && data.filters){
      if (isShowElement(data.filters, REPORT_FILTER.BANK_ACCOUNT)){
        bankDropdown.fetchOptions();
      }
      if(isShowElement(data.filters, REPORT_FILTER.PURE_CHEMICAL)){
        pureChemicalDropdown.fetchOptions();
      }
      if(isShowElement(data.filters, REPORT_FILTER.TANK_TRANSACTION)){
        tankTransactionDropdown.fetchOptions();
      }
      if(isShowElement(data.filters, REPORT_FILTER.SALE_ORDER)){
        saleOrderDropdown.fetchOptions();
      }
      if(isShowElement(data.filters, REPORT_FILTER.SKIM_CHEMICAL)){
        skimChemicalDropdown.fetchOptions();
      }
      if(isShowElement(data.filters, REPORT_FILTER.RAW_LATEX_CUSTOMER)){
        customerDropdown.fetchOptions();
      }
      if(isShowElement(data.filters, REPORT_FILTER.RAW_LATEX_SUPPLIER)){
        supplierDropdown.fetchOptions();
      }
      // if(isShowElement(data.filters, REPORT_FILTER.PRODUCTION_TYPE)){
      //   productionTypeDropdown.fetchOptions();
      // }
      // if (isShowElement(data.filters, REPORT_FILTER.SPECIES) || isShowElement(data.filters, REPORT_FILTER.MULTI_SPECIES)){
      //   speciesDropdown.fetchOptions();
      // }
      // if (isShowElement(data.filters, REPORT_FILTER.KERNEL_TYPE)) {
      //   kernelTypeDropdown.fetchOptions();
      // }
      // if(isShowElement(data.filters, REPORT_FILTER.PALMTREE)){
      //   plamTreeDropdown.fetchOptions();
      // }
    }
  }, [data])

  React.useEffect(() => {
    if (data && debouncedPureChemical) {
      if(isShowElement(data.filters, REPORT_FILTER.PURE_CHEMICAL))
        pureChemicalDropdown.fetchOptions();
    }
    
  },[debouncedPureChemical])

  React.useEffect(() => {
    if (data && debouncedSkimChemical) {
      if(isShowElement(data.filters, REPORT_FILTER.SKIM_CHEMICAL))
        skimChemicalDropdown.fetchOptions();
    }
    
  },[debouncedSkimChemical])

  React.useEffect(() => {
    if (data && debouncedTankTransaction) {
      if(isShowElement(data.filters, REPORT_FILTER.TANK_TRANSACTION))
        tankTransactionDropdown.fetchOptions();
    }
  },[debouncedTankTransaction])

  React.useEffect(() => {
    if (data && debouncedSaleOrder) {
      if(isShowElement(data.filters, REPORT_FILTER.SALE_ORDER))
        saleOrderDropdown.fetchOptions();
    }
    
  },[debouncedSaleOrder])

  React.useEffect(() => {
    if (data && debouncedCustomer) {
      if(isShowElement(data.filters, REPORT_FILTER.RAW_LATEX_CUSTOMER))
        customerDropdown.fetchOptions();
    }
    
  },[debouncedCustomer])

  React.useEffect(() => {
    if (data && debouncedSupplier) {
      if(isShowElement(data.filters, REPORT_FILTER.RAW_LATEX_SUPPLIER))
        supplierDropdown.fetchOptions();
    }
    
  },[debounceSupplier])
  // React.useEffect(() => {
  //   if (plantationWatch && data && data.filters && 
  //     isShowElement(data.filters, REPORT_FILTER.PLOT)) {
  //     plotDropdown.fetchOptions({ plantation: plantationWatch });
  //   }
  // }, [plantationWatch])

  // React.useEffect(() => {
  //   if (deliveryParams && data && data.filters && 
  //     isShowElement(data.filters, REPORT_FILTER.DELIVERY_TRANSACTION)) {
  //     deliveryDropdown.fetchOptions();
  //   }
  // }, [deliveryParams])

  return(
    <Modal
      title={data ? data.detail : "Report"}
      open={open}
      onCancel={onClose}
      maskClosable={false}
      width={haveFilter ? 850 : 400}
      footer={[
				<Button key={"1"} onClick={props.onClose}>{"ยกเลิก"}</Button>,
				props.data && !props.data.hideExcel && (
					<Button
						key={"2"}
						type={"primary"}
						loading={excelLoading}
						icon={<FileExcelOutlined />}
						style={{ background: colorSuccessTextActive }}
						onClick={() => handleSubmit("excel")}>
						{"Excel"}
					</Button>
				)
				,
				props.data && !props.data.hidePDF && (
					<Button 
						key={"3"}
						type={"primary"}
						loading={pdfLoading}
						style={{background: colorErrorTextActive}}
						icon={<FilePdfOutlined />}
						onClick={() => handleSubmit("pdf")}>
						{"PDF"}
					</Button>
				)
    ]}>
      
    {errorMessages && 
      <Alert
        message={errorMessages}
        type="error"
        showIcon
        style={{marginTop: "12px", marginBottom: "12px", textAlign: "left"}}
      />
    }

    {!haveFilter && 'เลือกประเภทไฟล์'}

    <Form 
      form={form}
      layout={"vertical"}>
        <Row gutter={16} justify={"start"}>
          
          {/* {data && data.filters && isShowElement(data.filters, REPORT_FILTER.COL) && (
            <Col xl={12} sm={12} xs={24} key={"showCol"}>
              <Form.Item 
                name={REPORT_FILTER.COL} 
                label={REPORT_FILTER_TH[REPORT_FILTER.COL]}
                rules={[{ required: isRequired(data.filters, REPORT_FILTER.COL) }]}>
                <Input 
                  autoComplete="off" 
                  placeholder={getPlaceHolder(data.filters, REPORT_FILTER.COL)}/>
              </Form.Item>
            </Col>
          )} */}

          {data && data.filters && isShowElement(data.filters, REPORT_FILTER.PURE_CHEMICAL) && (
            <Col xl={12} sm={12} xs={24} key={"showPlantation"}>
              <Form.Item 
                name={'chemical'} 
                label={REPORT_FILTER_TH[REPORT_FILTER.PURE_CHEMICAL]}
                rules={[{ required: isRequired(data.filters, REPORT_FILTER.PURE_CHEMICAL) }]}>
                <Select
                  showSearch
                  style={{ width : '100%'}}
                  placeholder={getPlaceHolder(data.filters, REPORT_FILTER.PURE_CHEMICAL)}
                  allowClear={true}
                  filterOption={false}
                  options={pureChemicalDropdown.options}
                  loading={pureChemicalDropdown.loading}
                  onSearch={debouncePureChemical}
                />
              </Form.Item>
            </Col>
          )}

          {data && data.filters && isShowElement(data.filters, REPORT_FILTER.SKIM_CHEMICAL) && (
            <Col xl={12} sm={12} xs={24} key={"showSkimChemical"}>
              <Form.Item 
                name={REPORT_FILTER.SKIM_CHEMICAL} 
                label={REPORT_FILTER_TH[REPORT_FILTER.SKIM_CHEMICAL]}
                rules={[{ required: isRequired(data.filters, REPORT_FILTER.SKIM_CHEMICAL) }]}>
                <Select
                  showSearch
                  style={{ width : '100%'}}
                  placeholder={getPlaceHolder(data.filters, REPORT_FILTER.SKIM_CHEMICAL)}
                  allowClear={true}
                  filterOption={false}
                  options={skimChemicalDropdown.options}
                  loading={skimChemicalDropdown.loading}
                  onSearch={debounceSkimChemical}
                />
              </Form.Item>
            </Col>
          )}

          {data && data.filters && isShowElement(data.filters, REPORT_FILTER.TANK_TRANSACTION) && (
            <Col xl={12} sm={12} xs={24} key={"showTankTransaction"}>
              <Form.Item 
                name={REPORT_FILTER.TANK_TRANSACTION} 
                label={REPORT_FILTER_TH[REPORT_FILTER.TANK_TRANSACTION]}
                rules={[{ required: isRequired(data.filters, REPORT_FILTER.TANK_TRANSACTION) }]}>
                <Select
                  showSearch
                  style={{ width : '100%'}}
                  placeholder={getPlaceHolder(data.filters, REPORT_FILTER.TANK_TRANSACTION)}
                  allowClear={true}
                  options={tankTransactionDropdown.options}
                  loading={tankTransactionDropdown.loading}
                  onSearch={debounceTankTransaction}
                  filterOption={false}
                />
              </Form.Item>
            </Col>
          )}

          {data && data.filters && isShowElement(data.filters, REPORT_FILTER.SALE_ORDER) && (
            <Col xl={12} sm={12} xs={24} key={"showSaleOrder"}>
              <Form.Item 
                name={REPORT_FILTER.SALE_ORDER} 
                label={REPORT_FILTER_TH[REPORT_FILTER.SALE_ORDER]}
                rules={[{ required: isRequired(data.filters, REPORT_FILTER.SALE_ORDER) }]}>
                <Select
                  showSearch
                  style={{ width : '100%'}}
                  placeholder={getPlaceHolder(data.filters, REPORT_FILTER.SALE_ORDER)}
                  allowClear={true}
                  options={saleOrderDropdown.options}
                  loading={saleOrderDropdown.loading}
                  onSearch={debounceSaleOrder}
                  filterOption={false}
                />
              </Form.Item>
            </Col>
          )}

          {data && data.filters && isShowElement(data.filters, REPORT_FILTER.DATE) && (
            <Col xl={12} sm={12} xs={24} key={"showDate"}>
              <Form.Item 
                name={REPORT_FILTER.DATE} 
                label={REPORT_FILTER_TH[REPORT_FILTER.DATE]}
                rules={[{ required: isRequired(data.filters, REPORT_FILTER.DATE) }]}>
                <DatePicker 
                  style={{ width: '100%' }} 
                  inputReadOnly={true} 
                  placeholder={getPlaceHolder(data.filters, REPORT_FILTER.DATE)}/>
              </Form.Item>
            </Col>
          )}

          {data && data.filters && isShowElement(data.filters, REPORT_FILTER.DATE_RANGE) && (
            <Col xl={12} sm={12} xs={24} key={"showDateRange"}>
              <Form.Item 
                name={REPORT_FILTER.DATE_RANGE} 
                label={REPORT_FILTER_TH[REPORT_FILTER.DATE_RANGE]} 
                rules={[{ required: isRequired(data.filters, REPORT_FILTER.DATE_RANGE) }]}>
                <DatePicker.RangePicker 
                  style={{ width: '100%' }} 
                  inputReadOnly={true} 
                  placeholder={getPlaceHolder(data.filters, REPORT_FILTER.DATE_RANGE)}/>
              </Form.Item>
            </Col>
          )}

          {data && data.filters && isShowElement(data.filters, REPORT_FILTER.MONTH) && (
            <Col xl={12} sm={12} xs={24} key={"showDate"}>
              <Form.Item 
                name={REPORT_FILTER.MONTH} 
                label={REPORT_FILTER_TH[REPORT_FILTER.MONTH]}
                rules={[{ required: isRequired(data.filters, REPORT_FILTER.MONTH) }]}>
                <DatePicker 
                  style={{ width: '100%' }} 
                  inputReadOnly={true} 
                  picker={"month"}
                  placeholder={getPlaceHolder(data.filters, REPORT_FILTER.MONTH)}/>
              </Form.Item>
            </Col>
          )}

          {data && data.filters && isShowElement(data.filters, REPORT_FILTER.MONTH_RANGE) && (
            <Col xl={12} sm={12} xs={24} key={"showDateRange"}>
              <Form.Item 
                name={REPORT_FILTER.MONTH_RANGE} 
                label={REPORT_FILTER_TH[REPORT_FILTER.MONTH_RANGE]} 
                rules={[{ required: isRequired(data.filters, REPORT_FILTER.MONTH_RANGE) }]}>
                <DatePicker.RangePicker 
                  style={{ width: '100%' }} 
                  inputReadOnly={true} 
                  picker={"month"}
                  placeholder={getPlaceHolder(data.filters, REPORT_FILTER.MONTH_RANGE)}/>
              </Form.Item>
            </Col>
          )}

          {data && data.filters && isShowElement(data.filters, REPORT_FILTER.BANK_ACCOUNT) && (
            <Col xl={12} sm={12} xs={24} key={"showPlantation"}>
              <Form.Item 
                name={REPORT_FILTER.BANK_ACCOUNT} 
                label={REPORT_FILTER_TH[REPORT_FILTER.BANK_ACCOUNT]}
                rules={[{ required: isRequired(data.filters, REPORT_FILTER.BANK_ACCOUNT) }]}>
                <Select
                  showSearch
                  style={{ width : '100%'}}
                  placeholder={getPlaceHolder(data.filters, REPORT_FILTER.BANK_ACCOUNT)}
                  initialvalues={''}
                  autoComplete='off'
                  filterOption={filterOption}
                  allowClear={true}
                  options={bankDropdown.options}
                  loading={bankDropdown.loading}
                />
              </Form.Item>
            </Col>
          )}

          {data && data.filters && isShowElement(data.filters, REPORT_FILTER.RAW_LATEX_CUSTOMER) && (
            <Col xl={12} sm={12} xs={24} key={"showCustomer"}>
              <Form.Item 
                name={REPORT_FILTER.RAW_LATEX_CUSTOMER} 
                label={REPORT_FILTER_TH[REPORT_FILTER.RAW_LATEX_CUSTOMER]}
                rules={[{ required: isRequired(data.filters, REPORT_FILTER.RAW_LATEX_CUSTOMER) }]}>
                <Select
                  showSearch
                  style={{ width : '100%'}}
                  placeholder={getPlaceHolder(data.filters, REPORT_FILTER.RAW_LATEX_CUSTOMER)}
                  allowClear={true}
                  options={customerDropdown.options}
                  loading={customerDropdown.loading}
                  onSearch={debounceCustomer}
                  filterOption={false}
                />
              </Form.Item>
            </Col>
          )}

          {data && data.filters && isShowElement(data.filters, REPORT_FILTER.TABLE_TANK_TRANSACTION) && (
            <Col xl={24} sm={24} xs={24} key={"showTableTankTransacltion"} width={1000}>
              <ReportTankTransactionTable url={data.url}/>
            </Col>
          )}

          {data && data.filters && isShowElement(data.filters, REPORT_FILTER.TABLE_SALE_ORDER) && (
            <Col xl={24} sm={24} xs={24} key={"showTableSaleOrder"} width={1000}>
              <ReportSaleOrderTable url={data.url}/>
            </Col>
          )}

          {data && data.filters && isShowElement(data.filters, REPORT_FILTER.TABLE_SALE_ORDER_SKIM) && (
            <Col xl={24} sm={24} xs={24} key={"showTableSaleOrderSkim"} width={1000}>
              <ReportSaleOrderTableSkim url={data.url}/>
            </Col>
          )}  

          {data && data.filters && isShowElement(data.filters, REPORT_FILTER.DELIVERY_SERIAL_ID) && (
            <Col xl={12} sm={12} xs={24} key={"showSerialID"}>
              <Form.Item 
                name={REPORT_FILTER.DELIVERY_SERIAL_ID} 
                label={REPORT_FILTER_TH[REPORT_FILTER.DELIVERY_SERIAL_ID]}
                rules={[{ required: isRequired(data.filters, REPORT_FILTER.DELIVERY_SERIAL_ID) }]}>
                <Input
                  style={{ width: '100%' }} 
                  placeholder={getPlaceHolder(data.filters, REPORT_FILTER.DELIVERY_SERIAL_ID)}/>
              </Form.Item>
            </Col>
          )}

          {data && data.filters && isShowElement(data.filters, REPORT_FILTER.RAW_LATEX_SUPPLIER) && (
            <Col xl={12} sm={12} xs={24} key={"showCustomer"}>
              <Form.Item 
                name={REPORT_FILTER.RAW_LATEX_SUPPLIER} 
                label={REPORT_FILTER_TH[REPORT_FILTER.RAW_LATEX_SUPPLIER]}
                rules={[{ required: isRequired(data.filters, REPORT_FILTER.RAW_LATEX_SUPPLIER) }]}>
                <Select
                  showSearch
                  style={{ width : '100%'}}
                  placeholder={getPlaceHolder(data.filters, REPORT_FILTER.RAW_LATEX_SUPPLIER)}
                  allowClear={true}
                  options={supplierDropdown.options}
                  loading={supplierDropdown.loading}
                  onSearch={debounceSupplier}
                  filterOption={false}
                />
              </Form.Item>
            </Col>
          )}

          {data && data.filters && isShowElement(data.filters, REPORT_FILTER.NO) && (
            <Col xl={12} sm={12} xs={24} key={"showCustomer"}>
              <Form.Item 
                name={REPORT_FILTER.NO} 
                label={REPORT_FILTER_TH[REPORT_FILTER.NO]}
                rules={[{ required: isRequired(data.filters, REPORT_FILTER.NO) }]}>
                <Input
                  style={{ width: '100%' }} 
                  placeholder={getPlaceHolder(data.filters, REPORT_FILTER.NO)}/>
              </Form.Item>
            </Col>
          )}
      </Row>
    </Form>
    </Modal>
  )
}

ReportModal.defaultProps = {
  open: false,
	data: null,
  onClose: () => {},
  onStartLoading: (type) => {},
	onEndLoading: () => {},
}

ReportModal.propTypes = {
	namePrefix: propTypes.string,
  open: propTypes.bool,
	data: propTypes.object,
  onClose: propTypes.func,
	onStartLoading: propTypes.func,
	onEndLoading: propTypes.func,
}